export default __webpack_public_path__ + "assets/images/2f378173890eaeb1f7fe3ce103391758.jpeg";